module.exports = __webpack_public_path__ + "img/38.a98ed14b.png";